import type { Location } from "@/types";
import { XIcon } from "@/app/components/system/Icons";
import { RoundButton } from "@/app/components/system/RoundButton";
import { LocationPicker } from "@/app/components/onboarding/LocationPicker";

interface LocationModalProps {
  onClose: () => void;
  onPick: (loc: Location) => void;
  current: Location | null;
}

/** Bottom-sheet modal for picking a garden location. */
export function LocationModal({ onClose, onPick, current }: LocationModalProps) {
  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-100 grid place-items-end justify-items-center backdrop-blur-[2px] animate-[loc-fade_0.18s_ease-out]"
      style={{ background: "oklch(0.2 0.02 140 / 0.45)" }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-130 bg-cream pt-4 pb-6 px-4 max-h-[78vh] flex flex-col rounded-t-[22px] animate-[loc-slide_0.24s_cubic-bezier(0.2,0.8,0.2,1)]"
      >
        <header className="flex items-center justify-between pt-1 pb-3.5 px-1">
          <h3 className="font-display font-medium text-lg m-0 text-ink tracking-tight">Set garden location</h3>
          <RoundButton onClick={onClose} aria-label="Close"><XIcon size={18} /></RoundButton>
        </header>

        <LocationPicker
          current={current}
          onPick={onPick}
        />
      </div>
    </div>
  );
}
